'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEntries = exports.getEntry = exports.getNotSetValue = exports.getName = exports.getIdTransform = exports.getIdInvariant = undefined;

var _immutable = require('immutable');

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _applyIdTransform = require('./applyIdTransform');

var _applyIdInvariant = require('./applyIdInvariant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getIdInvariant = exports.getIdInvariant = (0, _getIn2.default)(_keyPaths.ID_INVARIANT);
var getIdTransform = exports.getIdTransform = (0, _getIn2.default)(_keyPaths.ID_TRANSFORM);
var getName = exports.getName = (0, _getIn2.default)(_keyPaths.NAME);
var getNotSetValue = exports.getNotSetValue = (0, _getIn2.default)(_keyPaths.NOT_SET_VALUE);

/**
 * @description Get a single entry out of an indexed
 * async data by id.
 * @param {Any} id an id that passes the invariant
 * @param {IndexedAsyncData} indexedData
 */
var getEntry = exports.getEntry = (0, _curry2.default)(function (id, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);
  (0, _applyIdInvariant.applyIdInvariant)(id, indexedData);

  var key = (0, _applyIdTransform.applyIdTransform)(id, indexedData);
  return indexedData.getIn([].concat(_toConsumableArray(_keyPaths.ENTRIES), [key]), getNotSetValue(indexedData));
});

/**
 * @description Get multiple entries out of an IndexedAsyncData
 * record using an optional set of ids
 * @param {Set<Any>} ids a set of ids that pass the idInvariant
 * @param {IndexedAsyncData} indexedData
 */
var getEntries = exports.getEntries = function getEntries(indexedData) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.Set)();

  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);

  if (!ids.size) return indexedData.getIn(_keyPaths.ENTRIES);

  return ids.reduce(function (accumulator, id) {
    (0, _applyIdInvariant.applyIdInvariant)(id, indexedData);

    var key = (0, _applyIdTransform.applyIdTransform)(id, indexedData);
    return accumulator.set(key, indexedData.getIn([].concat(_toConsumableArray(_keyPaths.ENTRIES), [key]), getNotSetValue(indexedData)));
  }, (0, _immutable.Map)());
};